import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";
import { lookMoments } from "@/mocks/looks";
import { useSiteText } from "@/lib/siteContent";

export default function LooksMoments() {
  const eyebrow = useSiteText("looks.eyebrow", "Momentos");
  const title = useSiteText("looks.title", "Um par para cada momento");
  const text = useSiteText(
    "looks.text",
    "Do escritório ao fim de semana, escolhas que acompanham a sua rotina.",
  );
  return (
    <section id="looks" className="w-full scroll-mt-24 bg-background-50" aria-label="Looks para cada momento">
      <div className="px-4 py-16 md:px-8 md:py-24">
        <div className="mx-auto max-w-7xl">
          <SectionHeading eyebrow={eyebrow} title={title} text={text} />

          <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8">
            {lookMoments.map((moment, index) => (
              <Reveal key={moment.id} delay={(index % 2) * 90}>
                <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
                  <h3 className="font-heading text-2xl text-foreground-900 md:text-3xl">{moment.title}</h3>
                  <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">{moment.description}</p>

                  <div className="mt-5 grid flex-1 grid-cols-2 gap-3">
                    {moment.images.map((image, imageIndex) => (
                      <div
                        key={image}
                        className="relative h-[260px] overflow-hidden rounded-md bg-background-200 md:h-[320px]"
                      >
                        <img
                          src={image}
                          alt={`Combinação ${moment.title} — composição ${imageIndex + 1} de calçados e acessórios Auréa`}
                          title={`${moment.title} — calçados e acessórios Auréa`}
                          loading="lazy"
                          className="h-full w-full object-cover object-top transition-transform duration-700 ease-out hover:scale-105"
                        />
                      </div>
                    ))}
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}